var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 353,
    viewBox: "0 0 266 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 353,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.364 33.798C38.6133 33.798 38.8407 33.82 39.046 33.864C39.2513 33.908 39.42 34.0327 39.552 34.238C39.6987 34.4287 39.772 34.766 39.772 35.25C39.772 35.7047 39.6987 36.0347 39.552 36.24C39.42 36.4453 39.244 36.57 39.024 36.614C38.804 36.658 38.5693 36.68 38.32 36.68H34.778V47.57C34.778 47.8487 34.7487 48.1127 34.69 48.362C34.646 48.6113 34.5067 48.8167 34.272 48.978C34.052 49.1247 33.6707 49.198 33.128 49.198C32.6 49.198 32.2187 49.1247 31.984 48.978C31.7493 48.8167 31.61 48.6113 31.566 48.362C31.522 48.098 31.5 47.8267 31.5 47.548V36.68H27.914C27.6793 36.68 27.452 36.658 27.232 36.614C27.012 36.5553 26.836 36.4307 26.704 36.24C26.572 36.0347 26.506 35.6973 26.506 35.228C26.506 34.7587 26.572 34.4287 26.704 34.238C26.836 34.0327 27.012 33.908 27.232 33.864C27.452 33.82 27.6793 33.798 27.914 33.798H38.364ZM52.2116 49.198C51.669 49.198 51.2803 49.1173 51.0456 48.956C50.8256 48.7947 50.6863 48.582 50.6276 48.318C50.569 48.054 50.5396 47.7827 50.5396 47.504V35.492C50.5396 35.1987 50.569 34.9273 50.6276 34.678C50.6863 34.4287 50.833 34.2233 51.0676 34.062C51.3023 33.9007 51.691 33.82 52.2336 33.82C52.7763 33.82 53.1576 33.9007 53.3776 34.062C53.6123 34.2233 53.7516 34.4287 53.7956 34.678C53.8543 34.9273 53.8836 35.206 53.8836 35.514V47.526C53.8836 47.8047 53.8543 48.076 53.7956 48.34C53.7516 48.5893 53.6123 48.7947 53.3776 48.956C53.143 49.1173 52.7543 49.198 52.2116 49.198ZM42.8836 49.198C42.341 49.198 41.9523 49.1173 41.7176 48.956C41.483 48.7947 41.3363 48.582 41.2776 48.318C41.2336 48.054 41.2116 47.7827 41.2116 47.504V35.492C41.2116 35.1987 41.241 34.9273 41.2996 34.678C41.3583 34.4287 41.4976 34.2233 41.7176 34.062C41.9523 33.9007 42.3483 33.82 42.9056 33.82C43.4483 33.82 43.8296 33.9007 44.0496 34.062C44.2843 34.2233 44.4236 34.4287 44.4676 34.678C44.5263 34.9273 44.5556 35.206 44.5556 35.514V47.526C44.5556 47.8047 44.5263 48.076 44.4676 48.34C44.4236 48.5893 44.2843 48.7947 44.0496 48.956C43.815 49.1173 43.4263 49.198 42.8836 49.198ZM44.0276 42.906V40.002H50.8916V42.906H44.0276ZM57.56 49.198C57.032 49.198 56.6507 49.1173 56.416 48.956C56.1814 48.7947 56.0347 48.582 55.976 48.318C55.932 48.054 55.91 47.7827 55.91 47.504V35.47C55.91 35.1913 55.932 34.9273 55.976 34.678C56.0347 34.4287 56.1814 34.2233 56.416 34.062C56.6507 33.9007 57.0394 33.82 57.582 33.82H62.158C62.7594 33.82 63.3754 33.93 64.006 34.15C64.6367 34.37 65.216 34.7073 65.744 35.162C66.272 35.6167 66.6974 36.1813 67.02 36.856C67.3427 37.5307 67.504 38.33 67.504 39.254C67.504 39.87 67.4087 40.464 67.218 41.036C67.042 41.608 66.7707 42.136 66.404 42.62C66.0374 43.104 65.5827 43.522 65.04 43.874C64.4974 44.2113 63.874 44.4533 63.17 44.6H59.254V47.526C59.254 47.8047 59.2247 48.076 59.166 48.34C59.1074 48.5893 58.9607 48.7947 58.726 48.956C58.4914 49.1173 58.1027 49.198 57.56 49.198ZM66.844 48.758C66.3014 49.154 65.8687 49.308 65.546 49.22C65.2234 49.132 64.886 48.846 64.534 48.362L60.662 42.818L64.424 42.334L67.262 46.404C67.5114 46.756 67.6654 47.0567 67.724 47.306C67.7974 47.5553 67.7607 47.79 67.614 48.01C67.482 48.23 67.2254 48.4793 66.844 48.758ZM59.254 41.3H62.312C62.5174 41.3 62.73 41.2633 62.95 41.19C63.17 41.102 63.368 40.9773 63.544 40.816C63.72 40.6547 63.8667 40.442 63.984 40.178C64.1014 39.914 64.16 39.5987 64.16 39.232C64.16 38.8067 64.072 38.44 63.896 38.132C63.7347 37.824 63.5 37.5893 63.192 37.428C62.884 37.252 62.5247 37.164 62.114 37.164H59.254V41.3ZM76.1404 49.418C75.0844 49.418 74.0871 49.22 73.1484 48.824C72.2244 48.4133 71.4104 47.856 70.7064 47.152C70.0171 46.4333 69.4671 45.6047 69.0564 44.666C68.6604 43.7273 68.4624 42.7153 68.4624 41.63C68.4624 40.53 68.6531 39.5033 69.0344 38.55C69.4304 37.582 69.9657 36.7313 70.6404 35.998C71.3297 35.2647 72.1291 34.6927 73.0384 34.282C73.9477 33.8713 74.9231 33.666 75.9644 33.666C77.0204 33.666 78.0104 33.8713 78.9344 34.282C79.8731 34.678 80.6871 35.2353 81.3764 35.954C82.0657 36.6727 82.6084 37.5087 83.0044 38.462C83.4151 39.4153 83.6204 40.4493 83.6204 41.564C83.6204 42.6347 83.4224 43.6467 83.0264 44.6C82.6451 45.5387 82.1097 46.3747 81.4204 47.108C80.7311 47.8267 79.9317 48.3913 79.0224 48.802C78.1277 49.2127 77.1671 49.418 76.1404 49.418ZM76.0304 46.074C76.6171 46.074 77.1671 45.9567 77.6804 45.722C78.1937 45.4873 78.6411 45.172 79.0224 44.776C79.4184 44.3653 79.7191 43.8887 79.9244 43.346C80.1444 42.7887 80.2544 42.1873 80.2544 41.542C80.2544 40.926 80.1444 40.3467 79.9244 39.804C79.7044 39.2467 79.3964 38.7627 79.0004 38.352C78.6191 37.9267 78.1717 37.5967 77.6584 37.362C77.1597 37.1273 76.6171 37.01 76.0304 37.01C75.4584 37.01 74.9157 37.1273 74.4024 37.362C73.9037 37.5967 73.4564 37.9267 73.0604 38.352C72.6791 38.7627 72.3711 39.2467 72.1364 39.804C71.9164 40.3467 71.8064 40.9333 71.8064 41.564C71.8064 42.18 71.9164 42.7667 72.1364 43.324C72.3711 43.8667 72.6791 44.3433 73.0604 44.754C73.4564 45.1647 73.9037 45.4873 74.4024 45.722C74.9011 45.9567 75.4437 46.074 76.0304 46.074ZM90.3218 49.154C89.9405 49.154 89.6398 49.0807 89.4198 48.934C89.1998 48.7873 89.0385 48.6187 88.9358 48.428C88.8478 48.2373 88.7891 48.1053 88.7598 48.032L84.6238 36.042C84.4331 35.426 84.4038 34.9713 84.5358 34.678C84.6678 34.37 85.0491 34.1133 85.6798 33.908C86.0905 33.776 86.4205 33.7173 86.6698 33.732C86.9338 33.7467 87.1465 33.8493 87.3078 34.04C87.4838 34.2307 87.6378 34.5313 87.7698 34.942L90.5198 43.104L92.8298 35.052C92.8738 34.9053 92.9398 34.7367 93.0278 34.546C93.1305 34.3553 93.2918 34.1867 93.5118 34.04C93.7318 33.8933 94.0398 33.82 94.4358 33.82C94.8905 33.82 95.2278 33.9007 95.4478 34.062C95.6825 34.2233 95.8438 34.3993 95.9318 34.59C96.0198 34.7807 96.0858 34.9273 96.1298 35.03L98.4618 43.148L101.19 34.964C101.322 34.5533 101.468 34.2527 101.63 34.062C101.806 33.8567 102.026 33.7393 102.29 33.71C102.568 33.6807 102.913 33.7393 103.324 33.886C103.764 34.0473 104.072 34.216 104.248 34.392C104.424 34.568 104.512 34.788 104.512 35.052C104.526 35.3013 104.475 35.6313 104.358 36.042L100.222 48.032C100.192 48.12 100.126 48.2593 100.024 48.45C99.9358 48.626 99.7818 48.7873 99.5618 48.934C99.3565 49.0807 99.0485 49.154 98.6378 49.154C98.2418 49.154 97.9265 49.066 97.6918 48.89C97.4571 48.714 97.2885 48.5307 97.1858 48.34C97.0978 48.1347 97.0391 47.9953 97.0098 47.922L94.4798 39.716L91.9498 47.922C91.9351 47.9953 91.8765 48.1347 91.7738 48.34C91.6711 48.5453 91.5025 48.736 91.2678 48.912C91.0478 49.0733 90.7325 49.154 90.3218 49.154ZM116.267 49.242C115.666 49.242 115.241 49.1173 114.991 48.868C114.757 48.6187 114.639 48.186 114.639 47.57V35.47C114.639 34.854 114.757 34.4287 114.991 34.194C115.241 33.9447 115.673 33.82 116.289 33.82C116.905 33.82 117.331 33.9447 117.565 34.194C117.815 34.4433 117.939 34.8833 117.939 35.514V47.592C117.939 48.208 117.815 48.6407 117.565 48.89C117.331 49.1247 116.898 49.242 116.267 49.242ZM113.495 39.804C113.07 40.1707 112.689 40.3467 112.351 40.332C112.014 40.3173 111.655 40.1047 111.273 39.694C110.863 39.254 110.672 38.8507 110.701 38.484C110.731 38.1027 110.987 37.6993 111.471 37.274L114.749 34.37C115.16 34.0033 115.534 33.8347 115.871 33.864C116.223 33.8933 116.59 34.1207 116.971 34.546C117.367 34.9567 117.551 35.3453 117.521 35.712C117.492 36.0787 117.228 36.482 116.729 36.922L113.495 39.804ZM132.46 49.374C131.814 49.374 131.132 49.2713 130.414 49.066C129.695 48.8607 128.991 48.5527 128.302 48.142C127.612 47.7313 126.982 47.2107 126.41 46.58C125.852 45.9347 125.405 45.1867 125.068 44.336C124.745 43.4707 124.584 42.488 124.584 41.388C124.584 40.332 124.745 39.3933 125.068 38.572C125.405 37.736 125.852 37.01 126.41 36.394C126.967 35.778 127.59 35.272 128.28 34.876C128.969 34.4653 129.68 34.1647 130.414 33.974C131.147 33.7687 131.844 33.666 132.504 33.666C133.252 33.666 133.904 33.754 134.462 33.93C135.019 34.106 135.474 34.2893 135.826 34.48C136.178 34.656 136.398 34.7807 136.486 34.854C136.75 35.0153 136.999 35.1987 137.234 35.404C137.468 35.6093 137.593 35.8807 137.608 36.218C137.608 36.394 137.571 36.57 137.498 36.746C137.439 36.9073 137.344 37.0833 137.212 37.274C136.977 37.6113 136.75 37.8607 136.53 38.022C136.324 38.1687 136.112 38.242 135.892 38.242C135.716 38.242 135.547 38.198 135.386 38.11C135.239 38.022 135.048 37.9047 134.814 37.758C134.711 37.6847 134.564 37.5967 134.374 37.494C134.183 37.3767 133.926 37.274 133.604 37.186C133.281 37.0833 132.87 37.032 132.372 37.032C131.858 37.032 131.338 37.1273 130.81 37.318C130.296 37.494 129.82 37.7653 129.38 38.132C128.94 38.4987 128.588 38.968 128.324 39.54C128.06 40.0973 127.928 40.75 127.928 41.498C127.928 42.2753 128.06 42.9427 128.324 43.5C128.602 44.0573 128.962 44.5193 129.402 44.886C129.842 45.2527 130.318 45.5313 130.832 45.722C131.36 45.898 131.873 45.986 132.372 45.986C132.812 45.986 133.186 45.942 133.494 45.854C133.816 45.766 134.088 45.6633 134.308 45.546C134.542 45.414 134.74 45.2967 134.902 45.194C135.063 45.0913 135.224 44.996 135.386 44.908C135.562 44.82 135.738 44.776 135.914 44.776C136.119 44.776 136.324 44.8567 136.53 45.018C136.75 45.1793 136.97 45.436 137.19 45.788C137.322 45.9787 137.424 46.1693 137.498 46.36C137.571 46.536 137.6 46.712 137.586 46.888C137.586 47.196 137.468 47.4527 137.234 47.658C136.999 47.8487 136.75 48.0247 136.486 48.186C136.368 48.2447 136.141 48.3767 135.804 48.582C135.466 48.7727 135.019 48.9487 134.462 49.11C133.904 49.286 133.237 49.374 132.46 49.374ZM152.855 46.866C153.031 47.2327 153.126 47.548 153.141 47.812C153.155 48.0613 153.075 48.2887 152.899 48.494C152.737 48.6847 152.466 48.8753 152.085 49.066C151.498 49.3447 151.043 49.4253 150.721 49.308C150.398 49.2053 150.097 48.8607 149.819 48.274L145.507 39.254L141.217 48.274C140.923 48.846 140.615 49.1833 140.293 49.286C139.985 49.4033 139.537 49.3227 138.951 49.044C138.569 48.868 138.291 48.6847 138.115 48.494C137.953 48.2887 137.88 48.054 137.895 47.79C137.909 47.5113 138.012 47.1887 138.203 46.822L143.989 34.788C144.135 34.4947 144.348 34.26 144.627 34.084C144.92 33.908 145.221 33.82 145.529 33.82C145.749 33.82 145.954 33.864 146.145 33.952C146.335 34.0253 146.504 34.1353 146.651 34.282C146.812 34.4287 146.944 34.6047 147.047 34.81L152.855 46.866ZM141.811 45.612L143.175 42.774H147.861L149.225 45.612H141.811ZM156.044 49.198C155.516 49.198 155.135 49.1173 154.9 48.956C154.666 48.7947 154.519 48.582 154.46 48.318C154.416 48.054 154.394 47.7827 154.394 47.504V35.47C154.394 35.1913 154.416 34.9273 154.46 34.678C154.519 34.4287 154.666 34.2233 154.9 34.062C155.135 33.9007 155.524 33.82 156.066 33.82H160.642C161.244 33.82 161.86 33.93 162.49 34.15C163.121 34.37 163.7 34.7073 164.228 35.162C164.756 35.6167 165.182 36.1813 165.504 36.856C165.827 37.5307 165.988 38.33 165.988 39.254C165.988 39.87 165.893 40.464 165.702 41.036C165.526 41.608 165.255 42.136 164.888 42.62C164.522 43.104 164.067 43.522 163.524 43.874C162.982 44.2113 162.358 44.4533 161.654 44.6H157.738V47.526C157.738 47.8047 157.709 48.076 157.65 48.34C157.592 48.5893 157.445 48.7947 157.21 48.956C156.976 49.1173 156.587 49.198 156.044 49.198ZM165.328 48.758C164.786 49.154 164.353 49.308 164.03 49.22C163.708 49.132 163.37 48.846 163.018 48.362L159.146 42.818L162.908 42.334L165.746 46.404C165.996 46.756 166.15 47.0567 166.208 47.306C166.282 47.5553 166.245 47.79 166.098 48.01C165.966 48.23 165.71 48.4793 165.328 48.758ZM157.738 41.3H160.796C161.002 41.3 161.214 41.2633 161.434 41.19C161.654 41.102 161.852 40.9773 162.028 40.816C162.204 40.6547 162.351 40.442 162.468 40.178C162.586 39.914 162.644 39.5987 162.644 39.232C162.644 38.8067 162.556 38.44 162.38 38.132C162.219 37.824 161.984 37.5893 161.676 37.428C161.368 37.252 161.009 37.164 160.598 37.164H157.738V41.3ZM169.318 49.198C168.804 49.198 168.43 49.1173 168.196 48.956C167.976 48.7947 167.829 48.5893 167.756 48.34C167.682 48.076 167.646 47.7973 167.646 47.504V35.47C167.646 35.1913 167.675 34.9273 167.734 34.678C167.792 34.414 167.939 34.2013 168.174 34.04C168.408 33.8787 168.797 33.8053 169.34 33.82H173.3C174.356 33.82 175.338 34.0107 176.248 34.392C177.157 34.7733 177.956 35.3087 178.646 35.998C179.335 36.6873 179.87 37.494 180.252 38.418C180.633 39.342 180.824 40.3467 180.824 41.432C180.824 42.532 180.633 43.5587 180.252 44.512C179.87 45.4507 179.335 46.272 178.646 46.976C177.956 47.6653 177.15 48.208 176.226 48.604C175.316 49 174.319 49.198 173.234 49.198H169.318ZM170.99 45.832H173.3C174.092 45.832 174.803 45.6487 175.434 45.282C176.064 44.9007 176.563 44.3873 176.93 43.742C177.296 43.0967 177.48 42.356 177.48 41.52C177.48 40.684 177.296 39.936 176.93 39.276C176.563 38.616 176.064 38.1027 175.434 37.736C174.803 37.3547 174.084 37.164 173.278 37.164H170.99V45.832Z",
    fill: "#434343"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_69)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14_69)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 132.499,
    width: 116.844,
    height: 155.059,
    rx: 8.78524,
    transform: "rotate(-12.879 7 132.499)",
    fill: "#F6E09A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2352,
    y: 185.196,
    width: 26.795,
    height: 26.795,
    rx: 13.3975,
    transform: "rotate(-12.879 65.2352 185.196)",
    stroke: "white",
    strokeWidth: 6.58893
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.2394,
    y1: 213.589,
    x2: 78.3532,
    y2: 245.066,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.0575,
    y1: 218.884,
    x2: 104.535,
    y2: 239.771,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.6263,
    y1: 145.736,
    x2: 63.7401,
    y2: 177.213,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.4445,
    y1: 151.031,
    x2: 89.922,
    y2: 171.918,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14_69)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 119.229,
    width: 116.844,
    height: 155.059,
    rx: 8.78524,
    transform: "rotate(-6.50099 73 119.229)",
    fill: "#F6E09A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.021,
    y: 178.07,
    width: 26.795,
    height: 26.795,
    rx: 13.3975,
    transform: "rotate(-6.50099 125.021 178.07)",
    stroke: "white",
    strokeWidth: 6.58893
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.66,
    y1: 210.064,
    x2: 131.407,
    y2: 239.026,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.052,
    y1: 212.418,
    x2: 158.015,
    y2: 236.672,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.675,
    y1: 141.007,
    x2: 124.422,
    y2: 169.97,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.067,
    y1: 143.362,
    x2: 151.03,
    y2: 167.615,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14_69)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.1182,
    y: 99.6757,
    width: 15.3701,
    height: 120.166,
    rx: 7.68507,
    transform: "rotate(-52.9936 81.1182 99.6757)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.1182,
    y: 99.6757,
    width: 15.3701,
    height: 120.166,
    rx: 7.68507,
    transform: "rotate(-52.9936 81.1182 99.6757)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.1182,
    y: 99.6757,
    width: 15.3701,
    height: 120.166,
    rx: 7.68507,
    transform: "rotate(-52.9936 81.1182 99.6757)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.1182,
    y: 99.6757,
    width: 15.3701,
    height: 120.166,
    rx: 7.68507,
    transform: "rotate(-52.9936 81.1182 99.6757)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.56,
    y: 181.331,
    width: 15.3701,
    height: 120.166,
    rx: 7.68507,
    transform: "rotate(-142.994 103.56 181.331)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.56,
    y: 181.331,
    width: 15.3701,
    height: 120.166,
    rx: 7.68507,
    transform: "rotate(-142.994 103.56 181.331)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.56,
    y: 181.331,
    width: 15.3701,
    height: 120.166,
    rx: 7.68507,
    transform: "rotate(-142.994 103.56 181.331)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.56,
    y: 181.331,
    width: 15.3701,
    height: 120.166,
    rx: 7.68507,
    transform: "rotate(-142.994 103.56 181.331)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_14_69)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.467,
    y: 112,
    width: 116.844,
    height: 155.059,
    rx: 8.78524,
    transform: "rotate(9.07858 163.467 112)",
    fill: "#F6E09A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.773,
    y: 182.65,
    width: 26.795,
    height: 26.795,
    rx: 13.3975,
    transform: "rotate(9.07858 197.773 182.65)",
    stroke: "white",
    strokeWidth: 6.58893
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.694,
    y1: 221.698,
    x2: 187.553,
    y2: 243.082,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.431,
    y1: 216.819,
    x2: 213.815,
    y2: 247.961,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.513,
    y1: 153.303,
    x2: 199.371,
    y2: 174.687,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.25,
    y1: 148.424,
    x2: 225.634,
    y2: 179.565,
    stroke: "white",
    strokeWidth: 6.58893,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14_69",
    x: 4.70895,
    y: 106.455,
    width: 153.048,
    height: 184.075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.29105,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_14_69"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.662745 0 0 0 0 0.388235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14_69",
    x: 70.7089,
    y: 106,
    width: 138.23,
    height: 174.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.29105,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_14_69"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.662745 0 0 0 0 0.388235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14_69",
    x: 76.5808,
    y: 76.1183,
    width: 114.287,
    height: 114.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.53747
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.26874
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_14_69",
    x: 136.709,
    y: 112,
    width: 144.429,
    height: 178.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.29105,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_14_69"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5821
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.662745 0 0 0 0 0.388235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 252,
    fill: "white",
    transform: "translate(24 76)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard03);
export default __webpack_public_path__ + "static/media/card-03.a94dcd818ff611a6647d51faf8a853f5.svg";
export { ForwardRef as ReactComponent };